export default __webpack_public_path__ + "static/media/image-artist-6.b56cd6a4.jpg";